/**
 * Labstep
 *
 * @module components/EntityImport/Modal
 * @desc Modal for EntityImport
 */

import { Action } from 'labstep-web/components/EntityImport/Action/Menu';
import { EntityImportEmptyState } from 'labstep-web/components/EntityImport/EmptyState';
import { EntityImportTableContainer } from 'labstep-web/components/EntityImport/Table/Container';
import { Flex } from 'labstep-web/core/Flex';
import { Header } from 'labstep-web/core/Header';
import { ModalDefault } from 'labstep-web/core/Modal/Default';
import { useModalRoute } from 'labstep-web/hooks/modalRoute';
import type { ImportableEntity } from 'labstep-web/models';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
export const ENTITY_IMPORT_ROUTE_ID = 'entity-import';

export const EntityImportModal: React.FC = () => {
  const [entityName, setEntityName] =
    React.useState<ImportableEntity['entityName']>();
  const [templateId, setTemplateId] = React.useState<number>();
  const { open, toggleModal } = useModalRoute(ENTITY_IMPORT_ROUTE_ID);
  const { state: locationState } = useLocation<Record<
    string,
    unknown
  > | null>();
  useEffect(() => {
    if (locationState?.entityName) {
      setEntityName(
        locationState.entityName as ImportableEntity['entityName'],
      );
      setTemplateId(locationState.templateId as number);
    }
  }, [locationState?.entityName, locationState?.templateId]);
  if (!entityName) {
    return null;
  }
  return (
    <ModalDefault
      size="fullscreen"
      header="Import"
      modalHocProps={{ open, toggleModal }}
      content={
        <Flex column width="100%">
          <EntityImportEmptyState
            entityName={entityName}
            templateId={templateId}
          />
          <Header size="tiny">Previous Imports</Header>
          <EntityImportTableContainer
            targetEntityName={entityName}
            actions={[Action.revert]}
          />
        </Flex>
      }
    />
  );
};
